var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-skeleton-loading"},[_c('div',{staticClass:"skeleton-bac-animation"}),_vm._v(" "),_c('div',{staticClass:"skeleton-bac-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }